<template>
  <div>
    <ApexChart
      height="319"
      type="line"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  props: {
    metrics: Array,
    dataFrom: String,
    graphOptions: Object,
  },
  data() {
    return {};
  },
  computed: {
    options() {
      let options = {...this.graphOptions};
      // options.xaxis.categories = this.categories;
      options.yaxis.labels.formatter = function (value) {
        if (value === null) {
          return this.$t("heading.hosting.usage.graphs.noData");
        }
        return `${value} iops`;
      };
      options.legend = {
        show: false,
      };
      return options;
    },
    series() {
      return [
        {
          name: this.$t("heading.hosting.usage.graphs.read"),
          data: this.dataRead,
        },
        {
          name: this.$t("heading.hosting.usage.graphs.write"),
          data: this.dataWrite,
        },
      ];
    },
    dataRead() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "disk_read_iops") ? m.disk_read_iops : null,
        });
      }
      return data;
    },
    dataWrite() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "disk_write_iops") ? m.disk_write_iops : null,
        });
      }
      return data;
    },
    categories() {
      let categories = [];
      for (let d of this.dataRead) {
        categories.push(d.x);
      }
      return categories;
    },
  },
};
</script>